module.exports = __webpack_public_path__ + "static/img/login_line.3062d50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/login/login_line.png
// module id = OMxz
// module chunks = 1